import { Component, Inject } from "@angular/core";
import { TextPanel } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { PanelComponent } from "../../shared/panelComponent";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'text-panel',
  templateUrl: './textPanelComponent.html'
})
export class TextPanelComponent extends PanelComponent<TextPanel> {

  constructor(
    public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper
  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

}